export const REPORT_ID = 'slide-17';
export const SLIDE_NUMBER = 17;